import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { BankSelectComponent } from './components/bank-select/bank-select.component';
import { BannerCloseComponent } from './components/banner-close/banner-close.component';
import { CreditBlockedModalComponent } from './components/credit-blocked-modal/credit-blocked-modal.component';
import { CreditDueBannerComponent } from './components/credit-due-banner/credit-due-banner.component';
import { LineDoneModalComponent } from './components/line-done-modal/line-done-modal.component';
import { PhoneCodeInputComponent } from './components/phone-code-input/phone-code-input.component';
import { PhoneVerificationComponent } from './components/phone-verification/phone-verification.component';
import { StagingDataWarningComponent } from './components/staging-data-warning/staging-data-warning.component';

/**
 * Componentes compartidos del módulo Créditos que necesitan ser eager-loaded:
 *   - `CreditBlockedModalComponent`: lo abre el interceptor HTTP 423 en cualquier ruta.
 *     Incluye un input de referencia + "Notificar pago" que dispara `payInstallment`.
 *   - `CreditDueBannerComponent`: se usa en el home (DashboardModule lazy).
 *   - `BankSelectComponent` (FINA-3378): el selector de banco con búsqueda del pago, el abono, el
 *     modal de bloqueo (aquí) y la solicitud de la línea.
 *   - `BannerCloseComponent` (FINA-3378): la X de los banners de créditos del Home; la usan el
 *     banner de vencimiento (aquí) y los de `CreditosModule`, que importa este shared.
 *   - `StagingDataWarningComponent` (ADM-678): el aviso de datos de prueba. Va acá
 *     y no en `CreditosModule` porque lo necesitan tanto el modal de bloqueo
 *     (eager, declarado en este módulo) como el modal de pago y el formulario de
 *     solicitud (lazy). `CreditosModule` importa este shared, así que lo alcanza.
 *   - `LineDoneModalComponent` (FINA-3378): «Pagaste tu préstamo» / «Subiste a Nivel N». Lo monta
 *     `AppComponent` desde el vigía global (`LineMilestoneWatcherService`) en cualquier ruta.
 *   - `PhoneVerificationComponent` + `PhoneCodeInputComponent` (ADM-813): la verificación del teléfono
 *     por SMS/WhatsApp. La usan la solicitud de Fina Presta (lazy) y el paso «Confirmar» del onboarding
 *     fiscal (`FiscalOnboardingModule`, lazy), con su copy vía `copyOverrides`.
 *
 * Se importa en AppModule (para el modal) y en DashboardModule (para el banner). El módulo
 * principal `CreditosModule` (lazy) NO los declara — solo los consume vía import de este shared.
 */
@NgModule({
    // ADM-678: `NgbDatepickerModule` para el selector de fecha del modal de bloqueo
    // (el de pago lo recibe vía `AppCommonModule` → `NgbModule`).
    imports: [CommonModule, FormsModule, NgbModalModule, NgbDatepickerModule],
    declarations: [
        CreditBlockedModalComponent,
        CreditDueBannerComponent,
        StagingDataWarningComponent,
        BannerCloseComponent,
        BankSelectComponent,
        LineDoneModalComponent,
        PhoneVerificationComponent,
        PhoneCodeInputComponent,
    ],
    exports: [
        CreditBlockedModalComponent,
        CreditDueBannerComponent,
        StagingDataWarningComponent,
        BannerCloseComponent,
        BankSelectComponent,
        LineDoneModalComponent,
        PhoneVerificationComponent,
        PhoneCodeInputComponent,
    ],
})
export class CreditosSharedModule {}
